<template>
  <o-alert v-if="waitlist" :title="$t('waitlist.request')" show variant="info" class="m-6">
    <p class="text-sm">
      {{ $t('components.reservation.create.waitlist.content', { services: waitlist.servicesLabel, employees: waitlist.employeesLabel, dates: waitlist.datesLabel.join($t('general.listSeparator')) }) }}
    </p>
  </o-alert>
</template>

<script setup lang="ts">
import {
  OAlert,
} from '@/components/elements'

interface Props {
  waitlist?: object | null
}

withDefaults(defineProps<Props>(), {
  waitlist: null,
})
</script>
